import { Sport } from '__generated__/globalTypes';
import { useSportContext } from 'contexts/sport';

import { useFeatureFlags } from './useFeatureFlags';

export const useNewLobbyFF = () => {
  const { sport } = useSportContext();
  const {
    flags: {
      useNewLobby = {
        [Sport.NBA]: false,
        [Sport.FOOTBALL]: false,
        [Sport.BASEBALL]: false,
      },
    },
  } = useFeatureFlags();

  return useNewLobby[sport];
};
